const FEATURE_FLAGS = {
  COMPANY_EVENTS: "company-events",
  ANIXE_CLEAR_SEARCH: "fr-1747-fen-17964-anixe-search",
};

export default FEATURE_FLAGS;
